import { useBreakpointValue } from "@chakra-ui/react"
import { ImageCarouselAssetEntityHydrated } from "@jackfruit/common"

export const useCarouselAssets = (
  assetsMobile: ImageCarouselAssetEntityHydrated[],
  assetsTablet: ImageCarouselAssetEntityHydrated[],
  assetsDesktop: ImageCarouselAssetEntityHydrated[]
) => {
  const assets =
    useBreakpointValue({
      base: assetsMobile,
      md: assetsTablet,
      lg: assetsDesktop,
    }) ?? []

  return assets
}
